import { twMerge } from "tailwind-merge";

interface InternalNavbarButtonProps {
  className?: string;
  variant?: "navbar" | "footer";
}
function InternalNavbarButtons({ className, variant }: InternalNavbarButtonProps) {
  return (
    <>
      <div
        className={twMerge(
          "mr-[10px] h-[30px] w-[1px] self-center bg-[#12ac95] max-[991px]:hidden ",
          variant === "footer" && "hidden",
        )}
      ></div>
      <div className={twMerge("flex  items-center justify-start ", className)}>
        <a
          href="https://procomps.gg/experiments/case-studies.html"
          className={twMerge(
            "relative inline-block px-5 py-3 font-unbounded text-[14px] font-medium uppercase  text-neutral-0 no-underline hover:text-primary ",
            variant === "footer" && "pl-0 pr-5 text-[#868686] hover:text-[#868686]",
          )}
        >
          Case Studies
        </a>
        <a
          href="https://procomps.gg/project.html"
          className={twMerge(
            "relative inline-block px-5 py-3 font-unbounded text-[14px] font-medium uppercase  text-neutral-0 no-underline hover:text-primary ",
            variant === "footer" && "text-[#868686] hover:text-[#868686]",
          )}
        >
          Project
        </a>
        <a
          href="https://hub.procomps.gg/"
          target="_blank"
          className={twMerge(
            "relative inline-block px-5 py-3 font-unbounded text-[14px] font-medium uppercase  text-neutral-0 no-underline hover:text-primary ",
            variant === "footer" && "text-[#868686] hover:text-[#868686]",
          )}
          rel="noreferrer"
        >
          Hub
        </a>
      </div>
    </>
  );
}

export default InternalNavbarButtons;
